import { Box, Container, Typography } from "@material-ui/core";
import { useTheme, lighten } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import GridLoader from "react-spinners/GridLoader";
import type { Theme } from "src/theme";

function AppLoader({ text }: { text?: string }) {
  const theme = useTheme() as Theme;
  const isDark = theme.palette.type === "dark";
  const { custom: palette } = theme.palette.custom;

  const textColor = isDark
    ? lighten(palette.brandPrimary, 0.3)
    : palette.brandPrimary;

  return (
    <Container className="h-full justify-center flex items-center">
      <Box className="flex flex-col items-center">
        <GridLoader size={15} margin={2} color={palette.accent} />
        <Typography className="mt-3 text-sm" style={{ color: textColor }}>
          {text || "Loading..."}
        </Typography>
      </Box>
    </Container>
  );
}

export default AppLoader;

const LOADER_ESCALATION_DELAY_MS = 4000;
const LOADER_INITIAL_TEXT = "Loading...";
const LOADER_ESCALATED_TEXT = "Still loading your sales and transactions…";

/**
 * Full-page loader: shows `LOADER_INITIAL_TEXT`, then after `LOADER_ESCALATION_DELAY_MS`
 * switches to `LOADER_ESCALATED_TEXT` while this component remains mounted.
 */
export function AppLoaderWithEscalation() {
  const [escalated, setEscalated] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => {
      setEscalated(true);
    }, LOADER_ESCALATION_DELAY_MS);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <AppLoader text={escalated ? LOADER_ESCALATED_TEXT : LOADER_INITIAL_TEXT} />
  );
}
